import { useRef, useState } from "react";
import { faBox } from "@fortawesome/free-solid-svg-icons";
import { renderStatusCell } from "../cellRenderers";
import { statusHeaders } from "../constants";
import { exportTablePng } from "../exportUtils";
import { SectionTitle } from "./SectionTitle";

export function StatusBreakdownTable({ rows, isLoading }) {
  const sectionRef = useRef(null);
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = async () => {
    if (isLoading) return;
    setIsExporting(true);
    try { await exportTablePng(sectionRef, "DIFOT_By_Status"); }
    finally { setIsExporting(false); }
  };
  return (
    <section ref={sectionRef}>
      <SectionTitle title="DIFOT % By Status" icon={faBox} rulesKey="byStatus" onExport={handleExport} isExporting={isExporting} disabled={isLoading} />
      <div className="overflow-hidden rounded-2xl border border-[#d6dfeb] bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-[#cfd8e6]">
            <thead className="bg-[#233f66] text-white">
              <tr>
                <th className="whitespace-nowrap px-6 py-4 text-left text-xs font-black uppercase tracking-[0.08em]">
                  Status
                </th>
                {statusHeaders.map((header) => (
                  <th
                    key={header.key}
                    className="whitespace-nowrap px-6 py-4 text-right text-xs font-black uppercase tracking-[0.08em]"
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#d6dfeb] text-sm text-[#24385b]">
              {isLoading ? (
                <tr>
                  <td colSpan={statusHeaders.length + 1} className="px-6 py-8 text-center font-semibold text-[#7085a5]">
                    Loading data...
                  </td>
                </tr>
              ) : rows.length ? (
                rows.map((row, index) => (
                  <tr key={`${row.statusCategory}-${index}`} className="odd:bg-white even:bg-[#f6f8fc]">
                    <td className="whitespace-nowrap px-6 py-5 font-black">
                      {row.statusCategory || "—"}
                    </td>
                    {statusHeaders.map((header) => (
                      <td key={header.key} className="whitespace-nowrap px-6 py-5 text-right font-semibold">
                        {renderStatusCell(header.key, row[header.key])}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={statusHeaders.length + 1} className="px-6 py-8 text-center font-semibold text-[#7085a5]">
                    No data available for the selected filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
